import { createSagaActionTypes } from '../../../utils/actionFactory';

export const UPDATE_DATALIMITS = 'UPDATE_DATALIMITS';

export const actions = createSagaActionTypes('MULTIEDIT_DATALIMIT', [
  UPDATE_DATALIMITS
]);
